import React, { createContext, useContext, useState } from 'react';
import { LegalDocumentContextProviderProps, LegalDocumentContextType } from './interface';

export const LegalDocumentContext = createContext<LegalDocumentContextType>({} as LegalDocumentContextType);

export function LegalDocumentContextProvider({ children }: LegalDocumentContextProviderProps) {
  const [loadingLegalDocument, setLoadingLegalDocument] = useState<boolean>(false);

  return (
    <LegalDocumentContext.Provider value={{ loadingLegalDocument, setLoadingLegalDocument }}>
      {children}
    </LegalDocumentContext.Provider>
  );
}

export const useLegalDocumentContext = () => useContext(LegalDocumentContext);
